import { render, staticRenderFns } from "./PriceExplaination.vue?vue&type=template&id=1bb1f248&scoped=true"
import script from "./PriceExplaination.vue?vue&type=script&lang=js"
export * from "./PriceExplaination.vue?vue&type=script&lang=js"
import style0 from "./PriceExplaination.vue?vue&type=style&index=0&id=1bb1f248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb1f248",
  null
  
)

export default component.exports